import React from 'react';

// Material UI
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// Data
import { importerMessages as messages } from '../importer.messages';
import { pluralize } from '../../../../lib/helpers/text.helpers';

// Components
import { IntlMsg } from '../../IntlMsg/intl-msg.component';

interface IUnconfirmedMappingsDialogProps {
  open: boolean;
  unconfirmedColumns: string[];
  onConfirmAll: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

// Three-action variant of the shared ConfirmDialog: backdrop/escape must mean "keep editing",
// never "discard", so discarding gets its own explicit button instead of riding onClose.
export const UnconfirmedMappingsDialog: React.FC<IUnconfirmedMappingsDialogProps> = ({
  open,
  unconfirmedColumns,
  onConfirmAll,
  onDiscard,
  onCancel
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle><IntlMsg {...messages.dlgUnconfirmedTitle} /></DialogTitle>
    <DialogContent>
      <DialogContentText>
        <IntlMsg
          {...messages.dlgUnconfirmedMessage}
          values={{
            count: unconfirmedColumns.length,
            columns: unconfirmedColumns.join(', '),
            columnNoun: pluralize(unconfirmedColumns.length, 'column'),
            hasHave: pluralize(unconfirmedColumns.length, 'has', 'have'),
            itThem: pluralize(unconfirmedColumns.length, 'it', 'them')
          }}
        />
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}><IntlMsg {...messages.btnKeepEditing} /></Button>
      <Button onClick={onDiscard} color="secondary"><IntlMsg {...messages.btnDiscardContinue} /></Button>
      <Button onClick={onConfirmAll} color="primary" variant="contained" autoFocus>
        <IntlMsg {...messages.btnConfirmAllContinue} />
      </Button>
    </DialogActions>
  </Dialog>
);
